// src/utils/pinSession.js
import { getUser } from "./auth";

const HOUR = 60 * 60 * 1000;

function getKeyForUser() {
  const user = getUser();
  const id = user?.id ?? user?.email ?? "anon";
  return `pin_confirmed_at_${String(id)}`;
}

export function setPinConfirmedNow() {
  const k = getKeyForUser();
  const obj = { ts: Date.now(), lastActive: Date.now() };
  sessionStorage.setItem(k, JSON.stringify(obj));
}

export function clearPinConfirmed() {
  const k = getKeyForUser();
  sessionStorage.removeItem(k);
}

export function isPinSessionValid() {
  const k = getKeyForUser();
  const s = sessionStorage.getItem(k);
  if (!s) return false;
  try {
    const obj = JSON.parse(s);
    const now = Date.now();
    if (!obj.ts) return false;
    // expired after 1 hour from confirm OR 1 hour inactivity
    if (now - obj.ts > HOUR) return false;
    if (obj.lastActive && (now - obj.lastActive > HOUR)) return false;
    return true;
  } catch (e) {
    return false;
  }
}

export function touchPinSession() {
  const k = getKeyForUser();
  const s = sessionStorage.getItem(k);
  if (!s) return;
  try {
    const obj = JSON.parse(s);
    obj.lastActive = Date.now();
    sessionStorage.setItem(k, JSON.stringify(obj));
  } catch (e) { /* ignore */ }
}
